import * as selectors from './selectors';

import { DetailsSharedActionPage, SharedActionPage } from './model';
import { all, fork, put, select, takeEvery } from 'redux-saga/effects';
import { changePage, changePageSuccess } from './actions';

import { DetailsSharedActionTypes } from './types';
import { RimViews } from '../rim/model';
import { SvsViews } from '../svs/model';
import {changeView as rimChangeView} from '../rim/actions';
import {changeViewBasic as svsChangeView} from '../svs/actions';

function* handleChangePage(action: ReturnType<typeof changePage>) {
  const typedPayload = action.payload as SharedActionPage;

  switch (typedPayload.previousPage) {
      case DetailsSharedActionPage.RIM : {
        const previousView: RimViews = yield select(selectors.rimPreviousView);
        yield put(rimChangeView({view: previousView, instructionId: typedPayload.instructionId}));
        break;
      }
      case DetailsSharedActionPage.SVS : {
        const previousView: SvsViews = yield select(selectors.svsPreviousView);
        yield put(svsChangeView({view: previousView, instructionId: typedPayload.instructionId}));
        break;
      }
      default: {
        break;
      }
  }

  yield put(changePageSuccess(action.payload.page));
}

function* watchShared() {
  yield takeEvery(DetailsSharedActionTypes.CHANGE_ACTION_PAGE, handleChangePage);
}

function* detailsSharedSaga() {
  yield all([fork(watchShared)]);
}

export default detailsSharedSaga;
